<template>
  <ChapterHead>
    <div style="display: inline-block;">
      <span style="display: flex; align-items: center;">
        <img src="/static/helpid.png" style="width: 20px;height: 20px;margin-right: 6px" alt="">
        <span>申请编号：{{helpId}}</span>
        <span style="margin-left: 20px;">
          <slot></slot>
        </span>
      </span>
    </div>
    <span  style="display: inline-block;" slot="extra">
      <img src="/static/status-icon.png" style="width: 15px;height: 15px;margin-right: 6px; vertical-align: middle;" alt="">
      <span style="vertical-align: middle;">{{ apprStatusText }}</span>
    </span>
  </ChapterHead>
</template>

<script>
import ChapterHead from "@/components/business/ChapterHead";

export default {
  components: {
    ChapterHead
  },
  props: {
    helpId: String,
    apprStatusText: String
  }
}
</script>


// WEBPACK FOOTER //
// src/components/business/HelpIdBar.vue